import { is } from 'stdlib/is'

import preloadImage from '@common/preloadImage/preloadImage'

import fallback from './fallback'

/**
 * Betöltés.
 * @param container   - Maga az Element.
 * @param attr        - Attribútum.
 * @param fallbackSrc - Fallback src.
 */
export default function tryToLoad (container: HTMLElement, attr: string, fallbackSrc?: string): void {
  // Kell a split, mert spec karakterrel elválasztva akár több kép is lehet, amiket megpróbál betölteni.
  const urls = (container.getAttribute(attr) ?? '').split(',')

  const tmp = urls.shift()
  const url = is.string(tmp) ? tmp.trim() : ''

  // Ha nincs több próbálnivaló, akkor fallback és hagyjuk.
  if (!url?.length) {
    container.removeAttribute(attr) // Nem kell már az elem.
    fallback(container, fallbackSrc)

    return
  }

  if (is.empty(urls)) {
    container.removeAttribute(attr)
  }
  else {
    container.setAttribute(attr, urls.join(',')) // Visszarakjuk a maradékot.
  }

  // eslint-disable-next-line no-restricted-syntax -- Maradjon ez így a catch át miatt.
  preloadImage(url)
    .then(() => {
      if (is.instanceOf(container, HTMLImageElement)) {
        container.src = url
      }
      else {
        container.style.backgroundImage = `url(${ url })`
      }

      container.removeAttribute(attr)
      container.style.opacity = '1'
    })
    .catch(() => {
      tryToLoad(container, attr, fallbackSrc)
    })
}
